import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  content: React.ReactNode;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  content
}: LegalModalProps) {
  // Prevent body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  return <AnimatePresence data-id="element-90">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-black/60 z-[100] backdrop-blur-sm" data-id="element-91" />

          {/* Modal Container */}
          <div className="fixed inset-0 z-[101] flex items-center justify-center p-4 sm:p-6 pointer-events-none" data-id="element-92">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          type: 'spring',
          damping: 25,
          stiffness: 300
        }} className="bg-white w-full max-w-md rounded-2xl shadow-2xl flex flex-col max-h-[90vh] pointer-events-auto overflow-hidden" data-id="element-93">
              {/* Header */}
              <div className="flex items-center justify-between p-5 border-b border-gray-100" data-id="element-94">
                <h2 className="text-2xl font-heading font-bold text-warmBrown pr-4" data-id="element-95">
                  {title}
                </h2>
                <button onClick={onClose} className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full transition-colors flex-shrink-0" aria-label="Cerrar" data-id="element-96">
                  <XIcon className="w-5 h-5" data-id="element-97" />
                </button>
              </div>

              {/* Content (Scrollable) */}
              <div className="p-6 overflow-y-auto flex-1 custom-scrollbar" data-id="element-98">
                <div className="prose prose-sm max-w-none text-mutedBrown" data-id="element-99">
                  {content}
                </div>
              </div>

              {/* Footer */}
              <div className="p-5 border-t border-gray-100 bg-gray-50/50" data-id="element-100">
                <button onClick={onClose} className="w-full bg-[#8B2252] hover:bg-[#7A1D47] text-white font-bold py-3 px-6 rounded-full transition-colors duration-200" data-id="element-101">
                  Cerrar
                </button>
              </div>
            </motion.div>
          </div>
        </>}
    </AnimatePresence>;
}